/** First / middle / last joined with single spaces; empty or whitespace-only parts are dropped. */
export function joinPersonName(...parts: Array<string | null | undefined>): string {
  return parts.map(part => (part ?? '').trim()).filter(part => !!part).join(' ');
}
